<template>
  <div>
    <Button
      :size="15"
      :width="30"
      color="#1C69BB"
      colorText="#ffffff"
      icon="fas fa-info"
      class="mt-2 mb-3 mr-2"
      round
      traslate
      @click.native="openModal('modal'), ActionSetZindexTablaModal(true)"
    />
    <ui-modal ref="modal" title="Información importante" class="modal-paleta-colores"
              @close="ActionSetZindexTablaModal(false)">
      <div>
        <div class="d-flex flex-column mt-2">
          <div class="p-2">

            <div class="d-flex" style="text-align:justify">
              A continuación se presenta en detalle la paleta de colores
              que se utiliza para el tracking de las reservas.
            </div>

            <br>

            <div class="my-2">
              <span class="circle on-time-row"></span>
              <label class="circleDescription">Envíos a tiempo</label>
            </div>

            <div class="my-2">
              <span class="circle early-row"></span>
              <label class="circleDescription">Envíos con adelanto</label>
            </div>

            <div class="my-2">
              <span class="circle delay-row"></span>
              <label class="circleDescription">Envíos con atraso</label>
            </div>

            <div class="d-flex justify-content-end">
              <button class="btn btn-success mt-3" @click="closeModal('modal')">¡Entendido!</button>
            </div>
          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Keen UI
import UiModal from "keen-ui/lib/UiModal";
import Button from "../../../../common/Button";
import { mapActions } from "vuex";

// Componentes


export default {
  components: {
    UiModal,
    Button
  },
  methods: {

    ...mapActions(["ActionSetZindexTablaModal"]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    }
  }
};
</script>
<style>


.modal-paleta-colores .ui-modal__container {
  width: 25% !important;
}

.on-time-row {
  animation: green_bg_pulse 2.5s ease-in-out infinite;
  background: #28a745 !important;
}

.delay-row {
  animation: gold_bg_pulse 2.5s ease-in-out infinite;
  background: #d5b03d !important;
}

.early-row {
  animation: blue_bg_pulse 2.5s ease-in-out infinite;
  background: #339cdf !important;
}

@keyframes grey_pulse {
  0% {
    background-color: #a8a8a8;
    filter: brightness(1);
  }
  50% {
    background-color: #bcbcbc;
    filter: brightness(1.15);
    box-shadow: 0 0 12px rgba(180, 180, 180, 0.4);
  }
  100% {
    background-color: #a8a8a8;
    filter: brightness(1);
  }
}

@keyframes green_bg_pulse {
  0% {
    background-color: #28a745;
    filter: brightness(1);
  }
  50% {
    background-color: #40c55b;
    filter: brightness(1.2);
    box-shadow: 0 0 12px rgba(40, 167, 69, 0.5);
  }
  100% {
    background-color: #28a745;
    filter: brightness(1);
  }
}

@keyframes gold_bg_pulse {
  0% {
    background-color: #d5b03d;
    filter: brightness(1);
  }
  50% {
    background-color: #f0ce65;
    filter: brightness(1.2);
    box-shadow: 0 0 12px rgba(213, 176, 61, 0.5);
  }
  100% {
    background-color: #d5b03d;
    filter: brightness(1);
  }
}

@keyframes blue_bg_pulse {
  0% {
    background-color: #339cdf;
    filter: brightness(1);
  }
  50% {
    background-color: #5cb8f5;
    filter: brightness(1.2);
    box-shadow: 0 0 12px rgba(51, 156, 223, 0.5);
  }
  100% {
    background-color: #339cdf;
    filter: brightness(1);
  }
}

.circle {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
  border: 1px solid #e0e0e0;
}
</style>
